import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { MDText } from 'i18n-react';

import { titleCaseFirstLetter } from 'Utilities';
import { usePrevious } from 'Utilities/hooks';
import metatitle from 'Utilities/metatitle';

import texts from '../../texts.json';

const LocalT = new MDText(texts);

const t = (arg: string) => LocalT.translate(arg) as string;

export const useUpdatePageTitle = ({ acf, identifier }: any) => {
  const { hash, pathname } = useLocation();
  const prevPathname = usePrevious(pathname);

  const FALLBACK_DESCRIPTION = t(`${identifier}View.metaDescription`);
  const FALLBACK_TITLE = t(`${identifier}View.metaTitle`);

  const title = acf?.seo_title ?? acf?.header_title ?? FALLBACK_TITLE;
  const description = acf?.seo_description ?? acf?.header_description ?? FALLBACK_DESCRIPTION;

  const isReady = acf !== null;

  useEffect(() => {
    if (isReady) {
      if (title) {
        metatitle.formatTitle(pathname, titleCaseFirstLetter(title));
      }

      if (description) {
        metatitle.formatDescription(titleCaseFirstLetter(description));
      }
    }
  }, [isReady, hash, description, pathname, title, prevPathname]);
};
